import { ProjectQueryData } from '../queries/searchPage/searchProjects';
import { ProjectFilterParams } from '../services/search';
import { endpoints } from '../pages/api/endpoints';
import config from '../common/config';
import logger from '../common/helpers/logger/logger';
import { getPriceByQuery } from '../common/helpers/domain/priceOptions';
import { removeEmptyOrUndefinedValues } from '../common/helpers/utility/objectHelper';
import { USER_AGENT } from '../common/helpers/constants';

export const searchProjects = async (
  offset: number,
  searchQuery: ProjectFilterParams,
  perPage: number,
): Promise<ProjectQueryData['projectListCarouselQuery']> => {
  const url = `${config.baseUrl}${endpoints.projects}`;
  const minPrice = getPriceByQuery(searchQuery.minPrice);
  const maxPrice = getPriceByQuery(searchQuery.maxPrice);

  const queryParams = new URLSearchParams(
    removeEmptyOrUndefinedValues({
      ...searchQuery,
      offset: offset.toString(),
      perPage: perPage.toString(),
      minPrice: minPrice?.toString() || '',
      maxPrice: maxPrice?.toString() || '',
    }),
  );

  const requestUrl = `${url}?${queryParams.toString()}`;

  console.log('PROJECT SEARCH URL:', requestUrl);

  const response = await fetch(requestUrl, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'User-Agent': USER_AGENT,
    },
  });

  console.log('STATUS:', response.status);
  console.log('HEADERS:', Object.fromEntries(response.headers.entries()));

  const rawBody = await response.text();

  console.log('RAW RESPONSE BODY:', rawBody);

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status} body: ${rawBody}`);
  }

  const contentType = response.headers.get('content-type');

  if (!contentType || !contentType.includes('application/json')) {
    throw new Error(`Invalid response type: ${contentType}`);
  }

  const data = JSON.parse(rawBody);

  return data;
};

export const fetchProjectnetSuggestions = async (searchValue: string) => {
  try {
    const response = await fetch(
      `${endpoints.suggestedProjects}/?freeText=${encodeURIComponent(
        searchValue,
      )}`,
    );

    if (!response.ok)
      throw new Error('Failed to fetch projectnet project suggestions');

    const { data } = await response.json();
    return data || [];
  } catch (error) {
    logger.logError(
      'frontend-service.project-api.fetchProjectNetSearchSuggestions',
      'Error retrieving projects.',
      {
        error,
      },
    );
  }
};
